import { connect } from 'react-redux';

import CustomerNotificationsQuery from 'Query/CustomerNotifications.query';
import {
    ACCOUNT_LOGIN_URL,
    ACCOUNT_MENU_URL
} from 'Route/MyAccount/MyAccount.config';
import {
    DEFAULT_NAVIGATION_TABS_STATE,
    mapDispatchToProps,
    mapStateToProps,
    NavigationTabsContainer as SourceNavigationTabsContainer
} from 'SourceComponent/NavigationTabs/NavigationTabs.container';
import { isSignedIn } from 'Util/Auth';
import browserHistory from 'Util/History';
import { prepareQuery } from 'Util/Query';
import { executePost } from 'Util/Request/Request';
import { appendWithStoreCode } from 'Util/Url';

import NavigationTabs from './NavigationTabs.component';

export {
    mapStateToProps,
    mapDispatchToProps,
    DEFAULT_NAVIGATION_TABS_STATE
};

/** @namespace Elganso/Component/NavigationTabs/Container */
export class NavigationTabsContainer extends SourceNavigationTabsContainer {
    state = {
        haveNotifications: null
    };

    containerFunctions = {
        onMenuButtonClick: this.onMenuButtonClick.bind(this),
        onMyAccountButtonClick: this.onMyAccountButtonClick.bind(this),
        onMinicartButtonClick: this.onMinicartButtonClick.bind(this),
        onHomeButtonClick: this.onHomeButtonClick.bind(this),
        onSearchButtonClick: this.onSearchButtonClick.bind(this),
        onCategoriesButtonClick: this.onCategoriesButtonClick.bind(this)
    };

    containerProps() {
        const { device, navigationState, cartTotals } = this.props;
        const { haveNotifications } = this.state;

        return {
            device, navigationState, cartTotals, haveNotifications
        };
    }

    componentDidMount() {
        super.componentDidMount();
    }

    componentDidUpdate(prevProps) {
        super.componentDidUpdate(prevProps);

        if (isSignedIn() && this.state.haveNotifications === null) {
            this.setState({ haveNotifications: 0 });
            this.getNotifications();
        } else if (!isSignedIn()) {
            this.setState({ haveNotifications: null });
        }
    }

    getNotifications() {
        let idCustomer = null;

        if (localStorage.customer !== undefined && localStorage.customer !== null) {
            const customer = JSON.parse(localStorage.customer);

            const {
                data: {
                    id = null
                } = {}
            } = customer;

            idCustomer = id;
        }

        if (idCustomer !== null) {
            executePost(prepareQuery(CustomerNotificationsQuery.getNotificationsQuery({ user_id: idCustomer }))).then(
                /** @namespace Elganso/Component/NavigationTabs/Container/NavigationTabsContainer/getNotifications/executePost/then */
                (result) => {
                    if (result.getNotifications.length >= 1) {
                        this.setState({ haveNotifications: result.getNotifications.length });
                    } else {
                        this.setState({ haveNotifications: 0 });
                    }
                }
            );
        } else {
            this.setState({ haveNotifications: null });
        }
    }

    onMenuButtonClick() {
        // TODO: resolve issue when coming from CMS page
        browserHistory.push(appendWithStoreCode('/menu'));
        this.lastSeenMenu = 0;
    }

    onSearchButtonClick() {
        browserHistory.push(appendWithStoreCode('/searchtab'));
        this.lastSeenMenu = 0;
    }

    onMyAccountButtonClick() {
        const { pathname } = location;
        let url = '';

        if (isSignedIn()) {
            url = appendWithStoreCode(`${ ACCOUNT_MENU_URL }`);
        } else {
            url = appendWithStoreCode(ACCOUNT_LOGIN_URL);
            sessionStorage.setItem('redirectAfterLogin', location.pathname);
        }

        if (pathname !== url) {
            browserHistory.push(url);
        }
    }

    onCategoriesButtonClick() {
        browserHistory.push(appendWithStoreCode('/categories'));
        this.lastSeenMenu = 0;
    }

    render() {
        return (
            <NavigationTabs
              { ...this.containerProps() }
              { ...this.containerFunctions }
            />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(NavigationTabsContainer);
